export class ResidentialStatus {
  public id?: string;
  public name: string;
}
